import { ReactNode } from 'react'

import { useAuth } from 'src/auth'
import { isAdminOrOps } from 'src/lib/auth/permissions'

const AdminContainer = ({
  ignoreIsAdmin,
  children,
}: {
  ignoreIsAdmin?: boolean
  children: ReactNode
}) => {
  const { currentUser } = useAuth()

  if (ignoreIsAdmin || isAdminOrOps(currentUser)) {
    return children
  }
  return null
}

export default AdminContainer
